import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface RequisitionStatisticItem {
  slug: string
  label: string
  value: number | string | null
}

export function getUserStatisticsAction(): Promise<ApiResponse<RequisitionStatisticItem[]>> {
  return api.get<ApiResponse<RequisitionStatisticItem[]>>(`/statistics/users`)
}
